<template>
	<Teleport to="body">
		<div
			ref="AppToasts"
			class="app-toasts pa-4 pointer-events-none"
		>
			<TransitionGroup
				name="toasts"
				tag="ul"
				class="reset-list d-flex flex-column ga-3"
				:style="{ width: '25rem' }"
			>
				<li
					v-for="toast in toasts"
					:key="toast.uuid"
					ref="toast"
				>
					<CommonToast
						:toast="toast"
						:data-id="toast.uuid"
						:style="{ pointerEvents: 'auto' }"
						@close="removeToast(toast.uuid)"
					/>
				</li>
			</TransitionGroup>
		</div>
	</Teleport>
</template>

<script lang="ts" setup>
import CommonToast from '@/components/CommonToast.vue';
import { toasts, removeToast } from '@/composables/useToasts';
</script>

<style lang="scss" scoped>
.app-toasts {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 1000001;
}

.toasts-move {
    transition: all 0.25s ease;
}

.toasts-enter-active,
.toasts-leave-active {
    transition: all 0.25s ease;
}

.toasts-enter-from {
    opacity: 0;
    transform: scale(0.5);
}

.toasts-leave-to {
    opacity: 0;
    transform: translateY(-100%);
}

.toasts-leave-active {
    position: absolute;
}
</style>
